<template>
    <div class="body">
        <div class="body-t">
            <div class="mall">学生综合评价积分兑换 ▼</div>
        </div>
        <div class="box">
            <div class="box-l">
                <div class="l-head">
                    <div class="name">易小云</div>
                    <div>累计综评积分:5000</div>
                    <div>可兑换积分:200</div>
                    <div>已兑换积分:500</div>
                </div>
                <div class="l-content">
                    <div class="c-l">
                        <div class="title">综评兑换专区</div>
                        <div class="menu">
                            <div class="active">玩具</div>
                            <div>校庆纪念品</div>
                            <div>文具</div>
                            <div>功能卡</div>
                            <div>文具</div>
                            <div>功能卡</div>
                        </div>
                    </div>
                    <div class="c-r">
                        <div class="r-1">
                            <el-checkbox v-model="checked">只显示有库存</el-checkbox>
                        </div>
                        <div class="r-c">
                            <div class="r-c-box">
                                <div class="image">
                                    <el-image
                                            style="width: 140px; height: 140px"
                                            :src="require('../../assets/pointsImgs/entering.png')">
                                    </el-image>
                                </div>
                                <div class="tip">
                                    <!--<span class="tip-l" v-if="item.exchangeRule">{{item.exchangeRule.prizeNum}} {{item.exchangeRule.prizeName}}</span>-->
                                    <!--<span class="tip-r">剩余 {{item.inventory}} {{item.unit}}</span>-->
                                    <span class="tip-l">500积分</span>
                                    <span class="tip-r">剩余12件</span>
                                </div>
                                <div class="text">
                                    <!--{{item.specs}}-->
                                    本校十周年校庆木质“逢考必过”书签
                                </div>
                                <div class="r-c-bottom">
                                    <el-input-number size="small" v-model="num" :min="1" :max="9999"></el-input-number>
                                    <el-button type="danger" size="small">兑换</el-button>
                                </div>
                            </div>
                            <div class="r-c-box">
                                <div class="image">
                                    <el-image
                                            style="width: 140px; height: 140px"
                                            :src="require('../../assets/pointsImgs/entering.png')">
                                    </el-image>
                                </div>
                                <div class="tip">
                                    <!--<span class="tip-l" v-if="item.exchangeRule">{{item.exchangeRule.prizeNum}} {{item.exchangeRule.prizeName}}</span>-->
                                    <!--<span class="tip-r">剩余 {{item.inventory}} {{item.unit}}</span>-->
                                    <span class="tip-l">500积分</span>
                                    <span class="tip-r">剩余12件</span>
                                </div>
                                <div class="text">
                                    <!--{{item.specs}}-->
                                    本校十周年校庆木质“逢考必过”书签
                                </div>
                                <div class="r-c-bottom">
                                    <el-input-number size="small" v-model="num" :min="1" :max="9999"></el-input-number>
                                    <el-button type="danger" size="small">兑换</el-button>
                                </div>
                            </div>

                            <div class="r-c-box">
                                <div class="image">
                                    <el-image
                                            style="width: 140px; height: 140px"
                                            :src="require('../../assets/pointsImgs/entering.png')">
                                    </el-image>
                                </div>
                                <div class="tip">
                                    <!--<span class="tip-l" v-if="item.exchangeRule">{{item.exchangeRule.prizeNum}} {{item.exchangeRule.prizeName}}</span>-->
                                    <!--<span class="tip-r">剩余 {{item.inventory}} {{item.unit}}</span>-->
                                    <span class="tip-l">500积分</span>
                                    <span class="tip-r">剩余12件</span>
                                </div>
                                <div class="text">
                                    <!--{{item.specs}}-->
                                    本校十周年校庆木质“逢考必过”书签
                                </div>
                                <div class="r-c-bottom">
                                    <el-input-number size="small" v-model="num" :min="1" :max="9999"></el-input-number>
                                    <el-button type="danger" size="small">兑换</el-button>
                                </div>
                            </div>
                            <div class="r-c-box">
                                <div class="image">
                                    <el-image
                                            style="width: 140px; height: 140px"
                                            :src="require('../../assets/pointsImgs/entering.png')">
                                    </el-image>
                                </div>
                                <div class="tip">
                                    <!--<span class="tip-l" v-if="item.exchangeRule">{{item.exchangeRule.prizeNum}} {{item.exchangeRule.prizeName}}</span>-->
                                    <!--<span class="tip-r">剩余 {{item.inventory}} {{item.unit}}</span>-->
                                    <span class="tip-l">500积分</span>
                                    <span class="tip-r">剩余12件</span>
                                </div>
                                <div class="text">
                                    <!--{{item.specs}}-->
                                    本校十周年校庆木质“逢考必过”书签
                                </div>
                                <div class="r-c-bottom">
                                    <el-input-number size="small" v-model="num" :min="1" :max="9999"></el-input-number>
                                    <el-button type="danger" size="small">兑换</el-button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div class="r-t">
                    <!--<div>-->
                        <!--<span>兑换规则</span>-->
                        <!--提交兑换申请后，到302教室领取-->
                    <!--</div>-->
                    <!--<div>-->
                        <!--<div>我的兑换列表</div>-->
                        <!--<div>-->
                            <!--<div></div>-->
                            <!--<div>-->
                                <!--<div></div>-->
                                <!--<div></div>-->
                            <!--</div>-->
                            <!--<div>-->
                                <!--<div></div>-->
                                <!--<div></div>-->
                                <!--<div></div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="r-b"></div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "exchange",
        data() {
            return {
                checked: false,
                num: '',
            }
        },
        created() {

        },
        methods: {},
    }
</script>

<style scoped>
    .body {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .body-t {
        width: 100%;
        height: 87px;
        line-height: 87px;
        color: white;
        background: url("../../assets/pointsImgs/pointsHomebg1.png") no-repeat center 0;
        font-size: 48px;
        display: flex;
        align-items: center;
    }

    .mall {
        margin: 0 auto;
    }

    .box {
        flex: 1;
        width: 100%;
        display: flex;
        justify-content: space-around;
        box-sizing: border-box;
        padding: 20px 0 0;
        background: white;
    }

    .box-l {
        width: 63%;
        display: flex;
        flex-direction: column;
    }

    .l-head {
        width: 100%;
        height: 96px;
        line-height: 96px;
        border-radius: 30px 30px 0 0;
        background-color: #0051D6;
        text-align: center;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
        display: flex;
        justify-content: space-around;
        color: white;
        font-size: 22px;
    }

    .name {
        font-size: 28px;
    }

    .l-content {
        padding: 20px 0;
        height: 750px;
        display: flex;
    }

    .c-l {
        width: 340px;
        height: 100%;
        background: #F0F0F0;
        border-radius: 30px;
        text-align: center;
        overflow: hidden;
    }

    .title {
        font-size: 32px;
        font-weight: bold;
        padding: 20px 0;
    }

    .menu {
        width: 90%;
        height: 80%;
        margin: auto;
        background: #3071DB;
        border-radius: 30px;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
        font-size: 32px;
        color: white;
        overflow: auto;
    }

    .menu > div {
        height: 80px;
        line-height: 80px;
    }

    .active {
        background: white;
        color: #444444;
    }

    .menu::-webkit-scrollbar {
        width: 4px;
    }

    .menu::-webkit-scrollbar-thumb {
        border-radius: 10px;
         -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: #3071DB;
    }

    .menu::-webkit-scrollbar-track {
         -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: #F0F0F0;
    }

    .c-r {
        flex: 1;
        margin-left: 40px;
        display: flex;
        flex-direction: column;
    }

    .r-1 {
        border-bottom: 1px dotted #888181;
        padding: 20px;
    }


    .box-r {
        width: 32%;
    }

    .r-c {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
    }
    .r-c::-webkit-scrollbar {
        width: 4px;
    }

    .r-c::-webkit-scrollbar-thumb {
        border-radius: 10px;
         -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: #77aedb;
    }

    .r-c::-webkit-scrollbar-track {
         -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: #F0F0F0;
    }

    .r-c-box {
        margin: 30px 5%;
        /*width: 240px;*/
        width: 40%;
    }

    .name {
        text-align: center;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
    }

    .image {
        text-align: center;
    }

    .tip {
        padding: 5px 0;
        display: flex;
    }

    .tip > span {
        display: inline-block;
        flex: 1;
    }

    .tip-l {
        font-size: 14px;
        color: #EC2929;
    }

    .tip-r {
        font-size: 12px;
        color: #888181;
        text-align: right;
    }


    .text {
        height: 30px;
        margin: 5px 0 10px;
        font-size: 12px;
        color: #101010;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
         -webkit-line-clamp: 2;
         -webkit-box-orient: vertical;
    }

    .r-c-bottom{
        display: flex;
        justify-content: space-between;
    }

    .box-r{
        display: flex;
        flex-direction: column;
    }
    .r-t{
        flex: 1;
        border-radius: 30px 0 0 30px;
        background: #E5E5E5;
        margin-bottom: 20px;
    }
    .r-b{
        height: 105px;
        background: url("../../assets/pointsImgs/exchangebg.png") no-repeat center 0;
    }
</style>

